import { gql } from '@apollo/client';

/**
 * GraphQL queries for enhanced placeholders and deal field groups
 * Note: Team contact queries with teamId are defined separately
 */

// Deal Field Groups Queries
export const GET_DEAL_FIELD_GROUPS = gql`
  query PlaceholdersGetDealFieldGroups($dealId: ID!) {
    dealFieldGroups(dealId: $dealId) {
      id
      name
      slug
      slugRoot
      slugAttr
      slugIndex
      value
      documentCount
      contactBinding
      boundContact {
        id
        name
        email
        phone
        company
        title
        address
        contactType
        customFields
      }
      placeholderLinks {
        placeholder {
          uuid
          title
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// Document Placeholder Links with Deal Field Group info
export const GET_DOCUMENT_PLACEHOLDER_LINKS = gql`
  query PlaceholdersGetDocumentLinks($documentId: ID!) {
    getDocumentById(id: $documentId) {
      id
      placeholderLinks {
        id
        status
        currentValue
        lastSyncedAt
        placeholder {
          id
          uuid
          title
          isRequired
        }
        dealFieldGroup {
          id
          name
          value
          documentCount
          contactBinding
          boundContact {
            id
            name
            email
            phone
            company
            title
            address
            contactType
            customFields
          }
        }
      }
    }
  }
`;

/**
 * A placeholder's change log, newest first.
 *
 * Deliberately its own query: `value_history` is a JSONB column that grows with
 * every edit, and the sidebar's list queries must not drag it along for every
 * field on every load. Fetched only when the history slideout opens.
 *
 * Entries with `scope: "dealField"` come from the shared deal field the
 * placeholder is linked to — one edit there is recorded once and shows up in
 * every document using it.
 */
export const GET_PLACEHOLDER_VALUE_HISTORY = gql`
  query PlaceholdersGetValueHistory($placeholderUuid: ID, $linkableId: ID, $dealFieldGroupId: ID) {
    placeholderValueHistory(
      placeholderUuid: $placeholderUuid
      linkableId: $linkableId
      dealFieldGroupId: $dealFieldGroupId
    ) {
      value
      previous
      userId
      userName
      cause
      at
      scope
    }
  }
`;

// Placeholder Link Suggestions
export const GET_PLACEHOLDER_LINK_SUGGESTIONS = gql`
  query PlaceholdersGetLinkSuggestions($placeholderId: ID!, $dealId: ID!) {
    placeholderLinkSuggestions(placeholderId: $placeholderId, dealId: $dealId) {
      dealFieldGroup {
        id
        name
        value
        documentCount
        slug
      }
      score
      reason
    }
  }
`;

// Team Contacts for placeholder field binding (requires teamId)
export const GET_TEAM_CONTACTS_FOR_BINDING = gql`
  query PlaceholdersGetTeamContacts($teamId: ID!, $search: String) {
    teamContacts(teamId: $teamId, search: $search) {
      id
      name
      email
      phone
      company
      title
      address
      contactType
      customFields
      teamCustomFields {
        id
        fieldKey
        fieldLabel
        fieldType
      }
    }
  }
`;
